@if (isLoading()) {
  <aw-loading-animation
    [entityType]="EEntityType.ticketConfiguration"
    [relationType]="
      ERelationType.loadingDirectTicketPersonalData
    "></aw-loading-animation>
}
@if (currentProduct() && productForms.valid && !isLoading()) {
  <div class="flex flex-row gap-6">
    <aw-section
      [darkModeColor]="corporateDesign().colorAdmixtures.dark_surface_01"
      [testIdAffix]="'personal-data-page-section'"
      class="flex w-full flex-col gap-4 md:w-2/3">
      <aw-section-header>
        <aw-section-headline>{{
          textStore.texts()
            | filterTexts: ERelationType.personalData : EEntityType.generic
            | language
        }}</aw-section-headline>
      </aw-section-header>
      <div class="flex w-full flex-col gap-6" [formGroup]="personalDataForm">
        <aw-drop-down
          [id]="'personal-data-salutation'"
          [label]="
            textStore.texts()
              | filterTexts
                : ERelationType.newCustomerSalutation
                : EEntityType.generalArea
              | language
          "
          formControlName="salutation"
          [options]="salutationOptions() | toTranslatedOption"></aw-drop-down>
        <aw-text-input
          [id]="'personal-data-firstName'"
          [label]="
            textStore.texts()
              | filterTexts
                : ERelationType.newCustomerFirstName
                : EEntityType.generalArea
              | language
          "
          formControlName="firstName"></aw-text-input>
        <aw-text-input
          [id]="'personal-data-lastName'"
          [label]="
            textStore.texts()
              | filterTexts
                : ERelationType.newCustomerLastName
                : EEntityType.generalArea
              | language
          "
          formControlName="lastName"></aw-text-input>
        <aw-date-input
          [id]="'personal-data-dateOfBirth'"
          [label]="
            textStore.texts()
              | filterTexts
                : ERelationType.personalDataBirthdate
                : EEntityType.generalArea
              | language
          "
          [darkModeLabelColor]="
            corporateDesign().colorAdmixtures.dark_text_disabled
          "
          formControlName="dateOfBirth"></aw-date-input>
        <aw-text-input
          [id]="'personal-data-firstName'"
          [label]="
            textStore.texts()
              | filterTexts: ERelationType.email : EEntityType.loginLogout
              | language
          "
          formControlName="email">
          <div>
            {{
              textStore.texts()
                | filterTexts
                  : ERelationType.hasToBeValidEmail
                  : EEntityType.generic
                | language
            }}
          </div>
        </aw-text-input>
        <aw-checkbox
          [id]="'personal-data-agreement'"
          [label]="
            textStore.texts()
              | filterTexts: ERelationType.registryTos : EEntityType.generic
              | language
          "
          formControlName="agreement"></aw-checkbox>
      </div>
    </aw-section>
    <aw-direct-ticket-configuration-shopping-cart
      class="fixed bottom-0 left-0 z-20 w-full md:relative md:w-1/3"
      [page]="EPage.Configuration"
      [attr.data-testid]="'personal-data-configuration-page-shopping-cart'"
      [isDisabled]="!personalDataForm.valid || isLoading()"
      (onButtonClick)="
        proceedToTicketOwnerData()
      "></aw-direct-ticket-configuration-shopping-cart>
  </div>
}
